import React, { Component, Fragment } from 'react'
import { Form, Input, Button } from 'antd'

function hasErrors (fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field])
}

class LoginForm extends Component {
  state = {
    error: {
      status: false,
      message: null
    }
  }

  componentDidMount () {
    this.props.form.validateFields()
  }

  setError = (payload) => {
    this.setState({
      error: payload
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()

    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setError({
          status: false,
          message: null
        })
        this.props.authorizeAdmin(values.username, values.password)
          .then(() => {
            this.props.getUser()
          })
          .catch((response) => {
            this.handleReset()
            this.props.form.validateFields()
            this.setError({
              status: true,
              message: 'User not found' // response.data.error_description
            })
          })
      }
    })
  }

  handleReset = () => {
    this.props.form.resetFields()
  }

  render () {
    const { error } = this.state
    const { getFieldDecorator, getFieldsError, getFieldError, isFieldTouched } = this.props.form

    const usernameError = isFieldTouched('username') && getFieldError('username')
    const passwordError = isFieldTouched('password') && getFieldError('password')

    return (
      <Fragment>
        <Form onSubmit={this.handleSubmit} className='form'>
          { error.status ? <div className='form__error'>{ error.message }</div> : null }
          <Form.Item validateStatus={usernameError ? 'error' : ''} help={usernameError || ''}>
            { getFieldDecorator('username', {
              rules: [{ required: true,
                message: 'Please input your username',
                max: 320
              }]
            })(
              <Input placeholder='Username' name='username' maxLength={320} />
            )}
          </Form.Item>
          <Form.Item validateStatus={passwordError ? 'error' : ''} help={passwordError || ''}>
            { getFieldDecorator('password', {
              rules: [{ required: true,
                message: 'Please input your password'
              }]
            })(
              <Input placeholder='Password' name='password' type='password' />
            )}
          </Form.Item>
          <Form.Item>
            <Button type='indigo' htmlType='submit' className='login__button' loading={this.props.auth.isFetching} disabled={hasErrors(getFieldsError())}>Log In</Button>
          </Form.Item>
        </Form>
      </Fragment>
    )
  }
}

export default Form.create()(LoginForm)



// WEBPACK FOOTER //
// ./src/views/Secure/components/LoginForm/LoginForm.jsx